import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks/useAuth'
import { ReleaseContainer } from './ReleaseContainer/ReleaseContainer'
import './ReleaseNotes.scss'
import { GetReleaseItemOwners, GetUserReleases, Release } from './releases'

export function ReleaseNotes() {
  const [releases, setReleases] = useState<Release[]>([])
  const [selectedRelease, setSelectedRelease] = useState<Release>()
  const { t } = useTranslation('common')
  const { user } = useAuth()

  useEffect(() => {
    const visibleReleases = GetUserReleases(user)
    setReleases(visibleReleases)
    setSelectedRelease(visibleReleases.at(0))
  }, [user])

  return (
    <div className="fluid-container">
      <div className="row">
        <div className="col-md-3 col-12">
          <div className="detailTitle">
            <i className="icon-info" /> <span>{t('RELEASE_NOTES')}</span>
          </div>
          <ul className="releaseNotesList">
            {releases.map((r) => (
              <li className={selectedRelease === r ? 'active' : ''} onClick={() => setSelectedRelease(r)}>
                {`Release ${r.name}`} {user?.isAdmin && GetReleaseItemOwners(r).internal && <i className="icon-ail" />}{' '}
                {user?.isAdmin && GetReleaseItemOwners(r).customer && <i className="icon-users" />}
                {user?.isAdmin && GetReleaseItemOwners(r).interfleetPro && <i className="icon-4u" />}
              </li>
            ))}
          </ul>
        </div>
        {selectedRelease && (
          <div className="col-md-9 col-12">
            <div className="detailTitle">
              <span>{t('NOTES')}</span>
            </div>
            <ReleaseContainer release={selectedRelease} />
          </div>
        )}
      </div>
    </div>
  )
}
